<template>
    <v-dialog
        v-model="isOpen"
        max-width="350"
        @click:outside.prevent="onCloseModal()"
    >
        <v-card class="pa-5">
            <h3 class="text-center pb-4">{{ titlePopup }}</h3>
            <v-select
                v-model="typeOfSelect"
                label="Choose type of leave"
                :items="holidayItems"
                item-text="title"
                item-value="value"
            >
            </v-select>
            <v-layout class="d-flex flex-column">
                <v-flex class="align-center justify-space-around d-flex">
                    <v-btn color="error" @click="onCloseModal()">
                        Cancel
                    </v-btn>
                    <v-btn @click="validateForm">Create</v-btn>
                </v-flex>
            </v-layout>
        </v-card>
    </v-dialog>
</template>
<script>

import { mapActions } from 'vuex'

export default {
    props: ['isOpen', 'closeModal', 'selectedType', 'holidayItems'],
    data: () => ({
        titlePopup: 'Select a Leave type',
        typeOfSelect: null
    }),
    beforeDestroy () {
        this.typeOfSelect = ''
    },
    methods: {
        ...mapActions(['showAlert']),
        validateForm () {
            if (!(this.typeOfSelect)) {
                this.showAlert({
                    text: 'Please select a Leave type',
                    type: 'error'
                })
                return
            }
            const getTargetHolidayObject = this.holidayItems.filter((item) => item.value === this.typeOfSelect)[0]
            this.$emit('selectedType', {
                selectedType: this.typeOfSelect,
                additional: getTargetHolidayObject.additional
            })
        },
        onCloseModal () {
            this.typeOfSelect = ''
            this.$emit('closeModal')
        }
    }
}
</script>
